import FetchInterceptor from "configs/FetchInterceptor";

class PurchaseOrderServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/purchase/order/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/purchase/order/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }

  static async getByIds(requestBody) {
    const apiUrl = "/core/v1/purchase/order/get/data";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/purchase/order/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async update(requestBody) {
    const apiUrl = "/core/v1/purchase/order/update";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getPdf(id) {
    const apiUrl = `/core/v1/purchase/order/get/pdf/${id}`;
    const response = await FetchInterceptor.get(apiUrl, {
      responseType: "blob",
    });
    return response;
  }
}

export default PurchaseOrderServices;
